export interface Language {
  code: string;
  name: string;
  nativeName: string;
  direction: 'ltr' | 'rtl';
  flag: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    direction: 'ltr',
    flag: '🇺🇸',
  },
  {
    code: 'he',
    name: 'Hebrew',
    nativeName: 'עברית',
    direction: 'rtl',
    flag: '🇮🇱',
  },
];

export const RTL_LANGUAGES = ['he'];

// Cookie and header names (shared between client and server)
export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
export const LOCALE_HEADER_NAME = 'x-kindway-locale';

/**
 * Normalize language code (e.g., 'en-US' -> 'en', 'he-IL' -> 'he')
 * Safe to use on both client and server
 */
export function normalizeLocale(locale: string): string {
  // Extract base language code (first part before hyphen)
  const baseLocale = locale.split('-')[0].toLowerCase();
  
  // Check if it's a supported language
  const supported = SUPPORTED_LANGUAGES.find(
    lang => lang.code === baseLocale
  );
  
  return supported ? supported.code : 'en'; // Default to 'en' if not supported
}
